import { getBffUrl } from './EnvironmentUtils';
const queryParams = new URLSearchParams();
if (window.location.search.length > 0 || window.location.pathname !== '/') {
    const queryParam = new URLSearchParams();
    queryParam.append('redirectPath', window.location.pathname + window.location.search);
    queryParams.append('returnUrl', encodeURI('/?' + queryParam.toString()));
}

const REACT_APP_API_BASE_URL = getBffUrl(window.location.host);
export const LOGIN_URL =
    queryParams.size > 0 ? REACT_APP_API_BASE_URL + '/bff/login?' + queryParams.toString() : REACT_APP_API_BASE_URL + '/bff/login';
export const VIEW_REPORT_URL = '/view/';
export const COMPARE_REPORT_URL = '/compare/';
export const REPORTS_TABLE_URL = '/';
export const BFF_LOGOUT_URL_CLAIM_TYPE = 'bff:logout_url';
export const AVAILABLE_REPORT_ID_TO_VIEW = 183;
export const getLogoutUrl = (logoutUrl: string): string => {
    return REACT_APP_API_BASE_URL + logoutUrl;
};
export const getLogoutUrlWithSignInAsAnotherUser = (logoutUrl: string, environment: string): string => {
    const url = new URL(getLogoutUrl(logoutUrl));
    url.searchParams.append('loginasanotheruser', 'True');
    url.searchParams.append('ctxenv', environment);
    return url.toString();
};
export const PINNED_SEARCH_PARAM_NAME = 'pinned';
export const TOC_SEARCH_PARAM_NAME = 'search';
/** Disambiguates TOC items that share the same id (also used for title-only deep links like Execution Summary). */
export const TITLE_SEARCH_PARAM_NAME = 'title';
export const CALC_REVIEW_OVERVIEW_HELPID = 'ed15b0d2-c307-4e1f-acd2-f0b3c3571df4';
export const EXECUTION_SUMMARY_PAGE_ID = 'execution-summary';
export const VIEW_REPORT_EXECUTION_SUMMARY_URL = `/forms?${TITLE_SEARCH_PARAM_NAME}=Return%20Execution%20Summary`;
export const CALC_REVIEW_COMPARE_HISTORY_HELPID = 'de9bbd67-e254-49fd-b973-ebfd70002eb2';
export const DATA_CONTEXT_OVERVIEW_HELPID = '58991e92-9e8b-46b8-92cc-e02986564bd2';
